import React from 'react';
import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import StarIcon from '@mui/icons-material/Star';

type Props = {
  id: string;
  imageUrl: string;
  title: string;
  categories?: string[];
  tags?: string[];
  status: 'approved' | 'pending' | string;
  rating?: number;
};

const DiscoveredPlaceListItem: React.FC<Props> = ({
  id,
  imageUrl,
  title,
  categories = [],
  tags = [],
  status,
  rating = 0,
}) => {
  const navigate = useNavigate();

  const isApproved = (status || '').toLowerCase() === 'approved';

  return (
    <Card elevation={2} sx={{ borderRadius: 3 }}>
      <CardActionArea onClick={() => navigate(`/places/${id}`)}>
        <Box sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
          {/* Thumbnail */}
          <Box
            component="img"
            src={imageUrl}
            alt={title}
            sx={{
              width: 84,
              height: 84,
              borderRadius: 2,
              objectFit: 'cover',
              mr: 2,
              flexShrink: 0,
            }}
          />

          {/* Middle text */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography fontWeight={600} noWrap>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {(categories[0] || '')}
              {tags.length > 0 && ` • ${tags[0]}`}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {tags.slice(1, 3).join(' • ')}
            </Typography>
          </Box>

          {/* Right badges */}
          <Stack spacing={1} alignItems="flex-end">
            <Chip
              label={isApproved ? 'Approved' : 'Pending'}
              sx={{
                color: 'white',
                fontWeight: 600,
                borderRadius: 2,
                px: 1,
                background: isApproved
                  ? 'linear-gradient(90deg, #0D9488 0%, #D9F99D 100%)'
                  : 'linear-gradient(90deg, #B71C1C 0%, #FB8C00 100%)',
              }}
            />
            {isApproved && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  bgcolor: '#1B5E20',
                  color: 'white',
                  borderRadius: 2,
                  px: 1.25,
                  py: 0.25,
                }}
              >
                <Typography variant="body2" sx={{ lineHeight: 1 }}>
                  {rating}
                </Typography>
                <StarIcon sx={{ fontSize: 16 }} />
              </Box>
            )}
          </Stack>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default DiscoveredPlaceListItem;


